export default __webpack_public_path__ + "static/media/map-pin-construction-worker.e6c2ad92.svg";